import * as React from "react";
import { Route, Switch } from "react-router-dom";
import Summary from "./Settlements.Batches.Summary";
import List from "./Settlements.Batches.List";

const Batches = props => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/settlements/Batches"
      render={() => <List {...props} />}
    />
    <Route
      exact={true}
      path="/snapscan/settlements/Batches/:id/summary"
      render={routerProps => <Summary {...{ ...props, ...routerProps }} />}
    />
  </Switch>
);

export default Batches;
